import React, { useEffect } from 'react';
import Header from '../components/Header';
import DisclaimerFooter from '../components/DisclaimerFooter';
import { massingStudy as study } from '../data/pleasantStreetMassingData';
import './PleasantStreetMassing.css';

// Two documents about the same study, shown rather than transcribed: an
// interactive axonometric page and an 11-sheet drawing set. Both are static
// files under public/documents/ and are embedded here, each with a link to
// open it on its own — an iframe is awkward on a phone, and the drawings are
// easier to read full screen.
function PleasantStreetMassing() {
  useEffect(() => {
    document.title = `${study.title} - Brookline Notepad`;
  }, []);

  const url = (file) => `${process.env.PUBLIC_URL}/documents/${file}`;

  return (
    <div className="massing-page">
      <a href="#main-content" className="massing-skip-link">Skip to main content</a>
      <Header title={study.title} subtitle={study.subtitle} />

      <main id="main-content" tabIndex={-1} className="massing-content">
        <section className="massing-intro" aria-labelledby="massing-intro-heading">
          <h2 id="massing-intro-heading" className="visually-hidden">About this study</h2>
          <p className="massing-version">{study.version} - {study.date}</p>
          <ul className="massing-constraints">
            {study.constraints.map((c) => <li key={c}>{c}</li>)}
          </ul>
          {study.intro.map((para, i) => <p key={i}>{para}</p>)}
        </section>

        {study.documents.map((doc) => (
          <section key={doc.id} className="massing-doc" aria-labelledby={`doc-${doc.id}`}>
            <div className="massing-doc-head">
              <h2 id={`doc-${doc.id}`} className="massing-doc-title">{doc.title}</h2>
              <a
                className="massing-open"
                href={url(doc.file)}
                target="_blank"
                rel="noopener noreferrer"
              >
                Open on its own
                <span className="visually-hidden">
                  {doc.kind === 'pdf' ? ' (PDF, opens in new tab)' : ' (opens in new tab)'}
                </span>
              </a>
            </div>
            <p className="massing-doc-desc">{doc.description}</p>

            {/* The drawing set is a PDF, so the browser's own viewer handles it;
                the axonometrics are a web page and run in place. Either way the
                document keeps its own scrolling inside the frame. */}
            <div className="massing-frame" style={{ height: `${doc.height}px` }}>
              <iframe
                src={url(doc.file)}
                title={doc.frameTitle || doc.title}
                loading="lazy"
              />
            </div>

            {doc.kind === 'pdf' && (
              <p className="massing-doc-note">
                {doc.pages} sheets. If the viewer above does not display, open the
                PDF on its own using the link.
              </p>
            )}
          </section>
        ))}

        <DisclaimerFooter>
          <p>{study.disclaimer}</p>
        </DisclaimerFooter>
      </main>
    </div>
  );
}

export default PleasantStreetMassing;
